import { render } from "./cms-slot-table.vue?vue&type=template&id=2979651f"
import script from "./cms-slot-table.vue?vue&type=script&lang=js"
export * from "./cms-slot-table.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__